"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserDetailsEmployeeStats = void 0;
const user_details_1 = require("@app/reducer/user-details");
const store_1 = require("@app/store");
const user_details_employee_stats_1 = require("../../request/user-details-employee-stats");
const employee_card_context_1 = require("../employee-card-context");
const useEmployeeCardData_1 = require("./useEmployeeCardData");
const useUserDetailsEmployeeStats = () => {
    const { workspace, userId, period } = (0, employee_card_context_1.useEmployeeCard)();
    const dispatch = (0, store_1.useRootDispatch)();
    const { data } = (0, useEmployeeCardData_1.useEmployeeCardData)({
        actionName: 'user-details-employee-stats',
        requestor: async () => await (0, user_details_employee_stats_1.requestUserDetailsEmployeeStats)({
            workspaceId: workspace?.id ?? '',
            userId: userId ?? '',
            period,
        }),
        reducer: (data) => dispatch((0, user_details_1.setEmployeeStats)(data?.employeeStats)),
        selector: (state) => state.userDetails.employeeStats,
        listenDeps: [workspace?.id, userId, period],
    });
    return data;
};
exports.useUserDetailsEmployeeStats = useUserDetailsEmployeeStats;
